import axios from '.'

export default {
  index: (patientId, userId) =>
    axios.get(`/patients/${patientId}/care/${userId}/form`),

  store: (patientId, userId, careId, data) =>
    axios.post(`/patients/${patientId}/care/${userId}/form/${careId}`, data),

  show: (patientId, userId, careId) =>
    axios.get(`/patients/${patientId}/care/${userId}/form/${careId}`),

  updateReceipt(patientId, userId, id, data) {
    return axios.patch(`patients/${patientId}/care/${userId}/form/${id}`, data)
  },

  downloadAnesthesia: (
    patientId,
    userId,
    appointmentId,
    showWatermark,
    digitalSignature,
    manualSignature
  ) =>
    axios.get(
      `/patients/${patientId}/care/${userId}/form/${appointmentId}/download`,
      {
        responseType: 'blob',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        params: {
          showWatermark,
          digitalSignature,
          manualSignature
        }
      }
    )
}
